import { combineReducers } from 'redux'

import listCategory from './listCategory'
import detailCategory from './detailCategory'

export default combineReducers({
  listCategory: listCategory,
  detailCategory: detailCategory
})
